import React, { useState, useEffect, memo, useCallback } from 'react';
import { CreditCard } from 'lucide-react';
import { useCredits } from '../contexts/CreditContext';

const CreditCounter = memo(() => {
  const { credits, isAnimating } = useCredits();
  const [displayCredits, setDisplayCredits] = useState(credits);
  const [isPopping, setIsPopping] = useState(false);

  useEffect(() => {
    setDisplayCredits(credits);
  }, [credits]);

  useEffect(() => {
    if (isAnimating) {
      // Start the pop animation
      setIsPopping(true);
      
      // After a short delay, update the display credits
      const timer = setTimeout(() => {
        setDisplayCredits(credits);
        setIsPopping(false);
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [isAnimating, credits]);

  const handleClick = useCallback(() => {
    // Optional: Add click handler if needed
  }, []);

  return (
    <div 
      className={`flex items-center space-x-2 px-3 py-2 bg-gray-800 rounded-xl border border-gray-600 transition-all duration-300 ${
        isPopping ? 'scale-110 bg-gray-700' : ''
      }`}
      onClick={handleClick}
      style={{ boxShadow: isPopping ? '0 0 15px rgba(123, 97, 255, 0.5)' : '0 0 10px rgba(123, 97, 255, 0.2)' }}
    >
      <CreditCard className="h-4 w-4 text-[#7B61FF]" />
      <span className="text-sm font-semibold text-white">
        {displayCredits} Credits
      </span>
    </div>
  );
});

CreditCounter.displayName = 'CreditCounter';

export default CreditCounter; 